import { api } from "./core/api";
import { Cookie } from "./core/Cookie";
import { popMessage } from "./core/Popup";
import { entersite } from "./main";

export function login() : void {

    const form = document.createElement('form');
    
    form.innerHTML = `
        <h2>Logga in</h2>
        <div>
            <label for="username">Användarnamn</label>
            <input id="username" type="text" autocomplete="username" placeholder="Ditt korta användarnamn"  required>
        </div>
        <div>
            <label for="password">Password</label>
            <input id="password" type="password" placeholder="Ditt lösenord" required>
        </div>
        <div class="buttons">
            <button id="login">Logga in</button>
            <button id="cancel">Avbryt</button>
        </div>
    `;

    document.body.appendChild(form);

    const btnLogin = form.querySelector('#login') as HTMLButtonElement;
    btnLogin.addEventListener('click', async (e:Event) => {
        e.preventDefault();
        const username = (form.querySelector('#username') as HTMLInputElement).value;
        const password = (form.querySelector('#password') as HTMLInputElement).value;
        const resp = await api<{fullname:String}>('login', {
                username: username,
                password: password,
            });
        if (resp) {
            form.remove();

            popMessage(`<div class="prewelcome">Välkommen </div><div class="welcome">${resp.fullname}</div>`);
            Cookie.username = username;
            entersite(Cookie.pagename);
        }
        else {
            form.remove();
            popMessage(`Inloggning misslyckades`);
        }
    });
    
    const btnCancel = form.querySelector('#cancel') as HTMLButtonElement;
    btnCancel.addEventListener('click', (e:Event) => {
        e.preventDefault();
        form.remove();
    });
}
